<template>
  <section class="mt-12" v-if="tags">
    <h4 class="fs-20 font-medium mb-4">Good for...</h4>

    <checkbox
      v-for="tag in tags"
      @change="$emit('filter-changed')"
      :key="tag.value"
      v-model="options.tagOptions[`opt${tag.value}`]">
      {{ tag.title }}
    </checkbox>
  </section>
</template>

<script>
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  props: {
    tags: {
      type: Array,
      required: true,
    }
  },
  inject: ['options']
}
</script>